// Stores
import { UserProfileStore } from '../Stores';

/**********************************************************
 *  RequestHandler: Purpose is to wrap all outgoing http requests with token
 *  and any other body attributes.
 **********************************************************/

// Given an endpoint, make GET request to it and return data in promise
function getRequest(endpoint, auth) {

    //console.log('RequestHandler.getRequest(' + endpoint + ')');

    // Authorization
    var token = null;
    if(auth)
        token = UserProfileStore.getToken();

    return new Promise((resolve, reject) => {

        fetch(endpoint, {
            method: 'GET',
            headers: {
                'Accept' : 'application/json',
                'Content-Type' : 'application/json',
                'Authorization' : token
            }
        })
        .then(response => response.json())
        .then(response => {
        
            if(response.success)
                resolve(response.data);
            else
                reject(response);
        })
        .catch(error => reject(error));
        
    });

}


// Given an endpoint and a bodyObject, make POST request with it and return data in promise
function postRequest(endpoint, bodyObject, auth) {

    /*
    body should be : { field: value, field1: value2 }
    */

    //console.log('RequestHandler.postRequest(' + endpoint + ')');

    // Authorization
    var token = null;
    if(auth)
        token = UserProfileStore.getToken();

    return new Promise ( (resolve, reject) => {

        return fetch(endpoint, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization' : token
            },
            body: JSON.stringify(bodyObject)
        })
        .then(response => response.json())
        .then(response => {

            if(response.success)
                resolve(response.data);
            else
                reject(response);
        })
        .catch( error => reject(error));

    });

}


const RequestHandler = { getRequest, postRequest };
export default RequestHandler;






// WEBPACK FOOTER //
// ./src/Routes/RequestHandler.js